import React, { useState } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { TypeAnimation } from 'react-type-animation';
import CallIn from './component/CallIn';

// Styled components for the layout
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 100vh;
  color: white;
  text-align: left;
  padding: 0 20px;
  padding-right: 40px;

  @media (max-width: 1024px) {
    padding-right: 20px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding-right: 0;
  }

  @media (max-width: 480px) {
    padding: 20px;
  }
`;

const TextContainer = styled.div`
  max-width: 50%;
  padding: 20px;

  @media (max-width: 1024px) {
    max-width: 60%;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 20px 0;
  }
`;

const fadeInOut = `
  @keyframes fadeInOut {
    0% {
      transform: perspective(500px) rotateX(0deg) rotateY(0deg);
      opacity: 0;
    }
    50% {
      transform: perspective(500px) rotateX(10deg) rotateY(10deg);
      opacity: 1;
    }
    100% {
      transform: perspective(500px) rotateX(0deg) rotateY(0deg);
      opacity: 0;
    }
  }
`;

// Title with 3D animation
const Title = styled(motion.h1)`
  font-size: 3rem;
  margin-bottom: 20px;
  position: relative;
  animation: fadeInOut 4s ease-in-out infinite;

  /* 3D Text effect */
  text-shadow: 4px 4px 8px rgba(0, 0, 0, 0.5), -4px -4px 8px rgba(0, 0, 0, 0.3), 2px 2px 6px rgba(0, 0, 0, 0.2);

  @media (max-width: 1024px) {
    font-size: 2.5rem;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  /* Inject keyframes styles into the component */
  &::before {
    content: "";
    display: none;
  }

  /* Add keyframes directly in style */
  ${fadeInOut}
`;

const Subtitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 40px;

  @media (max-width: 1024px) {
    font-size: 1.8rem;
  }

  @media (max-width: 768px) {
    font-size: 0.7rem;
  }
`;

const Button = styled(motion.button)`
  background: #61dafb;
  border: none;
  border-radius: 5px;
  color: white;
  font-size: 1rem;
  padding: 10px 20px;
  cursor: pointer;
  outline: none;
  &:hover {
    background: #21a1f1;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const SmartphoneContainer = styled.div`
  position: relative;
  align-items: center;
  width: 320px; /* Default width */
  height: 600px; /* Default height */
  margin: 0 auto; /* Center horizontally */

  @media (max-width: 1024px) {
    width: 290px; /* Resize for tablets */
    height: 580px;
  }

  @media (max-width: 768px) {
    width: 240px; /* Resize for small screens */
    height: 480px;
  }

  @media (max-width: 480px) {
    width: 200px; /* Resize for very small screens */
    height: 400px;
  }
`;

const AppUIScreen = styled.img`    
  position: absolute;
  padding: 10px;
  width: 100%; /* Full width of smartphone */
  height: 100%; /* Full height of smartphone */
  object-fit: contain; /* Ensures the app UI fits without distortion */
  border-radius: 50px; /* Optional: rounded corners */
  pointer-events: none;
  z-index: 2;
`;


const ButtonList = styled.div`
  align-items:center;
  bottom: 10%;
  z-index: 1; /* Place buttons behind the smartphone and app UI */
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const BackgroundButton = styled(motion.button)`
  background: linear-gradient(to right, ${(props) => props.bgColor || 'rgba(0, 0, 0, 0.7)'}, rgba(0, 0, 0, 0)); /* Gradient overlay */  
  color: ${(props) => props.textColor || 'white'}; /* Dynamic background color */;  
  border: none;  
  border-radius: 25px 0px 0px 25px;
  font-size: 1.1rem;
  padding: 10px 10px 10px 10px;
  cursor: pointer;
  
  &:hover {
    transform: scaleX(1.3);
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

// Animated background component that fades in with a gradient overlay
const FadeInBackground = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  z-index: -2; /* Ensure it's behind all other content */
`;

const GradientOverlay = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.2)); /* Gradient overlay */
  z-index: -1; /* Place it above the background but below the UI */
`;

const Home = () => {
  const [appImage, setAppImage] = useState('assets/l`network/user-profile.png');
  const [bgImage, setBgImage] = useState('assets/background/restoran.jpg');
  const [appSelected, setAppSelected] = useState(0);

  const [isVisible, setIsVisible] = useState(true);

  const optionApps = [
    {
      title: 'L`Network',
      icon: 'assets/logo/icon_lacademik.png',
      image: 'assets/l`network/user-profile.png',
      background: 'assets/background/restoran.jpg',
      color: '#f29f02'
    },
    {
      title: 'E-Hajj',
      icon: 'assets/catalog/logo/icon_buffet.png',
      image: 'assets/catalog/ehajj_phone.png',
      background: 'assets/background/ehajj.jpg',
      color: '#fff',
      textColor: '#000'
    },    
    {
      title: 'Umroh.com',
      icon: 'assets/catalog/logo/icon_buffet.png',
      image: 'assets/catalog/home-umroh.com.png',
      background: 'assets/background/bmt.jpg',
      color: '#B7B7B7',
      textColor: '#000'
    },
    {
      title: 'BMT Nasional',
      icon: 'assets/catalog/logo/icon_buffet.png',
      image: 'assets/catalog/bmt_phone.png',
      background: 'assets/background/bmt.jpg',
      color: '#B7B7B7',
      textColor: '#000'
    },
  ];

  return (
    <Container>
      {/* Animated background that fades in when changed */}
      <FadeInBackground
        key={bgImage} // Key ensures the background fades in every time it changes
        animate={{ opacity: 1 }}
        initial={{ opacity: 0 }}
        transition={{ duration: 1 }}
        style={{ backgroundImage: `url(${bgImage})` }}
      />

      {/* Gradient overlay */}
      <GradientOverlay
        animate={{ opacity: 1 }}
        initial={{ opacity: 0 }}
        transition={{ duration: 1 }}
      />

      <TextContainer className='pt-2'>
        <CallIn child={<Title>L`Network</Title>} />
        <CallIn child={<Subtitle>IT & Apps Development</Subtitle>} />

        <TypeAnimation
          sequence={['Simplification Is the Key', 1300, 'From Confusion to Certainty', 1300]}
          wrapper="h3"
          speed={50}
          style={{ fontSize: '1em', display: 'inline-block' }}
          repeat={Infinity}
        />

        <br />

        <Link to='/service'>
          <Button
            style={{ backgroundColor: '#f29f02' }}
            className="mt-4"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            Get Started
          </Button>
        </Link>
      </TextContainer>

      <div className='flex flex-row '>
        <div className='pt-8 pl-2'>
          <ButtonList>
            {optionApps.map((app, index) => (
              <BackgroundButton     
                bgColor={index == appSelected ? app.color : "#000"}
                textColor={index == appSelected ? app.textColor : '#fff'}
                key={app.title}
                whileHover={{ x: -25 }}
                whileTap={{ x: -25 }}
                onClick={() => {
                  setIsVisible(false);
                  setTimeout(() => {
                    setAppSelected(index);
                    setAppImage(app.image);
                    setBgImage(app.background); // Change the background image
                    setIsVisible(true);
                  }, 1000);
                }}>
                {app.title}
              </BackgroundButton>
            ))}
          </ButtonList>
        </div>
        <div className='pt-5'>
          <motion.div
            initial={{ x: '50%' }}        // Initial position (off screen)        
            animate={{ x: isVisible ? 0 : '50%', opacity:  isVisible ? 1 : 0  }}  // Animates based on `isVisible`
            exit={{ x: '50%' }}            // Move off screen again
            transition={{ duration: 1 }}    // Duration of animation          
          >
            <SmartphoneContainer>
                <AppUIScreen src={appImage} alt="App UI" />
            </SmartphoneContainer>
          </motion.div>
        </div>        
      </div>

    </Container>
  );
};

export default Home;